/**
 * Gate 2 — Coherence Restoration
 *
 * Detects post-hoc coherence fitting: the output's claim appears
 * to have mutated toward the available evidence rather than
 * evidence updating a held prior. Characteristic linguistic
 * pattern: conclusion-first phrasing followed by evidence cited
 * as confirmation rather than as the basis of inference.
 *
 * Trip routes to abstention with reason='coherence_restoration_detected'.
 */

const COHERENCE_RESTORATION_PHRASES = [
  'which confirms', 'this confirms', 'which validates', 'this validates',
  'as expected', 'as predicted', 'as we anticipated', 'consistent with our thesis',
  'this demonstrates that we', 'this shows that we were', 'proving our point',
  'vindicates', 'this supports the view that', 'further confirms',
  'consistent with what we thought', 'aligns with our prior belief',
  'exactly as theorized',
];

/**
 * @param {import('../disciplineEnforcer.js').EnforcerEnvelope} envelope
 * @param {object} [_config]
 * @returns {import('../disciplineEnforcer.js').GateResult}
 */
export function checkCoherenceRestoration(envelope, _config = {}) {
  const text = (envelope.rawOutput || '').toLowerCase();

  if (!text) {
    return { gateName: 'coherence_restoration', verdict: 'pass', reason: null, payload: null };
  }

  const matchedPhrases = COHERENCE_RESTORATION_PHRASES.filter(p => text.includes(p));

  if (matchedPhrases.length > 0) {
    return {
      gateName: 'coherence_restoration',
      verdict: 'trip',
      reason: 'coherence_restoration_detected',
      payload: { matchedPhrases },
    };
  }

  return { gateName: 'coherence_restoration', verdict: 'pass', reason: null, payload: null };
}
